import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function AudienceTopCities({ cities }) {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Top villes
        </Typography>

        <List dense>
          {cities.map((city, i) => (
            <ListItem key={city.name}>
              <ListItemText
                primary={`${i + 1}. ${city.name}`}
                secondary={`${city.count} participants`}
              />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </CustomCard>
  );
}
